module.exports = __webpack_public_path__ + "img/menu-inventory.1e4071e8.svg";